export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[320px] lg:min-h-[560px]">
        <img
          src="https://readdy.ai/api/search-image?query=Richly%20styled%20flat%20lay%20on%20a%20rustic%20oak%20wooden%20table%20with%20visible%20grain%20and%20knots%2C%20featuring%20a%20pair%20of%20tan%20boots%2C%20a%20woven%20straw%20hat%2C%20a%20small%20stack%20of%20leather-bound%20journals%2C%20a%20ceramic%20espresso%20cup%2C%20brass%20sunglasses%2C%20and%20linen%20napkins%2C%20warm%20candlelight%20ambiance%2C%20moody%20editorial%20still%20life%20photography%2C%20no%20text&width=900&height=700&seq=cta-left-v2&orientation=portrait"
          alt="Kakobuy Spreadsheet — produkty"
          title="Kakobuy Spreadsheet — kolekcja produktów"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 p-8 md:p-12">
          <span className="text-white/60 text-xs font-label uppercase tracking-wider">Odkryj Więcej</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-2 leading-tight">
            Znajdź<br />Swój Styl<br />z Kakobuy
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-16">
        <div className="max-w-[420px] text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Zacznij Zakupy<br />z Kakobuy
          </h2>
          <p className="mt-5 text-foreground-500 text-base leading-relaxed">
            Nie czekaj dłużej — odkryj nasz kompletny arkusz zakupowy i ciesz się wygodnym przeglądaniem produktów. Tysiące zadowolonych użytkowników już nam zaufało. Dołącz do nich już dziś!
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 mt-8 px-10 py-4 bg-foreground-900 text-white font-label font-bold text-sm rounded-full whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}